<!--
 * @Author: your name
 * @Date: 2021-08-29 22:45:17
 * @LastEditTime: 2022-03-21 02:24:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /private-claim/src/views/ClaimMaterial/UploadSubmit.vue
-->
<template>
  <div>
    <van-Dialog
      v-model="show"
      confirm-button-text="退出"
      confirm-button-color="#f1a705"
      @confirm="toMe"
      class="no-scroll"
      theme="round-button"
    >
      <h2 class="dialog-title" slot="title">提交成功！</h2>
      <div class="dialog-content">
        <p>您的资料已经全部提交成功！</p>
        <p>
          <b class="color-red">{{ subWaitDays }}</b>
          <span>之内会由{{name}}的理赔专员帮您完成初审，请保持手机畅通；</span>
        </p>
        <br />
        <p>如有疑问请联系：{{ phone }}</p>
        <p>工作时间：</p>
        <p>{{ workTime }}</p>
        <br />
        <p>
          请持续关注柚儿健康公众号，右下角“无创保险”菜单中，可以查看“理赔进度”关注最新动态
        </p>
      </div>
    </van-Dialog>
    <div class="footer">
      <van-checkbox v-model="checked" class="checkbox" shape="square">
        您已同意《<span @click.stop="showAgreemen" class="agreement"
          >柚儿健康公众号平台用户协议</span
        >》和《<span @click.stop="showCollect" class="agreement"
          >理赔个人信息收集及使用授权条款</span
        >》
        <span class="color-red font-size-mini">
          （本人承诺本次提供用于理赔报案的所有医疗单据，不再用于其他理赔报销使用，一经发现，本人愿意承担由此产生的一切法律后果。）
        </span>
      </van-checkbox>
      <van-button @click="submit" class="btn" type="info">提交</van-button>
    </div>
    <UserAgreement ref="agreemen" />
    <CollectAgreement ref="collect" />
  </div>
</template>
<script>
import { Toast } from "vant";
import UserAgreement from "./UserAgreement";
import CollectAgreement from "./CollectAgreement";

export default {
  components: {
    UserAgreement,
    CollectAgreement,
  },
  props: {
    upload: {
      type: Function,
      default: () => {},
    },
    serNo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      checked: false,
      show: false,
      agreement: false,
      name: "",
      phone: "",
      subWaitDays: "",
      workTime: ""
    };
  },
  methods: {
    async submit() {
      if (!this.checked)
        return Toast("请先勾选页面的\n”同意《柚儿健康公众号平台用户协议》“");

      await this.upload();

      try {
        const { data } = await this.$api.user.saveSubClaim({
          serNo: this.serNo,
        });

        this.name = data.name;
        this.phone = data.phone;
        this.subWaitDays = data.subWaitDays;
        this.workTime = data.workTime.join(" ")

        this.show = true;
      } catch (error) {
        Toast.fail(error.message || "保存失败");
      }
    },
    toMe() {
      this.$router.push("/mine/search");
    },
    showAgreemen() {
      this.$refs.agreemen.show = true;
    },
    showCollect() {
      this.$refs.collect.show = true;
    },
  },
};
</script>
<style lang="less" scoped>
.btn {
  width: 100%;
  margin-top: 10px;
}
.checkbox {
  margin: 0 10px;
  align-items: flex-start;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  padding-top: 14px;
}
.dialog-content {
  margin: 8px;
  padding: 6px;
  overflow-y: auto;
  font-size: 14px;
  font-weight: 500;
  line-height: 26px;
}
.dialog-title {
  font-size: 18px;
}
.agreement {
  color: dodgerblue;
  cursor: pointer;
  text-decoration: underline;
}

.color-red {
  color: @red;
}

.font-size-mini {
  font-size: 12px;
}
</style>
